import { observer } from 'mobx-react-lite'
import { useLocation, useParams } from 'react-router'
import { Box, Button, Divider, Dropdown, IconButton, layoutStore } from 'shared/ui'
import { uiStore } from 'shared/store/uiStore'
import { ChatbotRoutes } from 'entities/ExportRouters'
import { AgentEditCustomTitle } from 'pages/chatbot/ui/AgentEditCustomTitle/AgentEditCustomTitle'
import { AgentEditHeader } from 'pages/chatbot/ui/AgentEditHeader/AgentEditHeader'
import { ChatbotStatusBadge } from 'pages/chatbot/ui/ChatbotStatus'
import { useUnifiedAgentContext } from 'pages/chatbot/ui/UnifiedAgent/context/unifiedAgentContext'

export const Header = observer(() => {
  const {
    nameInputStore,
    isSaving,
    handleSaveAgent,
    handlePublishAgent,
    handleDisableAgent,
    isChatLoading,
    model,
    blockerStore,
    testAgentStore,
  } = useUnifiedAgentContext()
  const { name, setName, error: nameError } = nameInputStore
  const { state: payload } = useLocation()
  const { isAdditionalXSView } = layoutStore
  const { isActive, status } = model
  const { agentId } = useParams()

  const isSaveDisabled = isSaving || isChatLoading || (!!agentId && !blockerStore.isExistChanges)

  const renderActions = () => [
    {
      iconButtonComponent: (
        <Box display='flex' alignItems='center' gap='8px'>
          {(isAdditionalXSView || isActive) && (
            <Dropdown
              width={162}
              placement='bottom-start'
              icon={'moreHorizontal'}
              tooltipProps={{
                label: 'Show actions',
                placement: 'top-end',
              }}
              iconButtonProps={{
                fontSize: 20,
                variant: 'contained',
                size: 'medium',
                ariaLabel: 'Actions_showActions',
              }}
              items={[
                ...(isActive
                  ? [
                      {
                        id: 1,
                        label: 'Disable agent',
                        onClick: handleDisableAgent,
                      },
                    ]
                  : []),
                ...(isAdditionalXSView
                  ? [
                      {
                        id: 2,
                        label: 'Test agent',
                        onClick: testAgentStore.openModal,
                        disabled: false,
                      },
                    ]
                  : []),
              ]}
            />
          )}
          {!isActive && (
            <Button
              text={agentId ? 'Save changes' : 'Save as draft'}
              contained='secondary'
              onClick={() => handleSaveAgent()}
              disabled={isSaveDisabled}
            />
          )}
          <Button
            text={isActive ? 'Publish changes' : 'Activate'}
            contained='primary'
            onClick={() => handlePublishAgent()}
            disabled={isSaving || isChatLoading}
          />
          <Box display='flex' alignItems='center'>
            <Divider
              orientation='vertical'
              sx={{ height: '16px !important', marginRight: '8px' }}
            />
            <IconButton
              ariaLabel='close_setting'
              icon='close'
              variant='contained'
              color='tertiary'
              size='medium'
              onClick={() =>
                uiStore.changeRoute({
                  path: `/${ChatbotRoutes.root}/${ChatbotRoutes.texting}`,
                })
              }
            />
          </Box>
        </Box>
      ),
    },
  ]

  return (
    <AgentEditHeader
      customTitle={
        <AgentEditCustomTitle
          template={{ icon: 'stars', color: 'var(--purple-70)' }}
          name={name}
          setName={setName}
          error={nameError}
          isAutoFocus={payload?.duplicateId}
        />
      }
      rightTitleContent={status !== null ? <ChatbotStatusBadge status={status} /> : null}
      actionsGap={8}
      actions={renderActions()}
    />
  )
})
